import api from './api';

export async function getInvoicesByStand(mobileStandId, date) {
  const { data } = await api.get(`/invoice/mobile-stand/${mobileStandId}`, { params: date ? { date } : {} });
  return data;
}

export async function getInvoiceById(id) {
  const { data } = await api.get(`/invoice/${id}`);
  return data;
}

export async function createInvoice(payload) {
  const { data } = await api.post('/invoice', payload);
  return data;
}

export async function cancelInvoice(id) {
  const { data } = await api.put(`/invoice/cancel/${id}`);
  return data;
}

// Pantalla de cocina
export async function getKitchenOrders(mobileStandId) {
  const { data } = await api.get(`/invoice/kitchen/${mobileStandId}`);
  return data;
}

export async function deliverOrder(id) {
  const { data } = await api.put(`/invoice/deliver/${id}`);
  return data;
}
